import { render, staticRenderFns } from "./AdminComponent.vue?vue&type=template&id=380f9f78&"
import script from "./AdminComponent.vue?vue&type=script&lang=js&"
export * from "./AdminComponent.vue?vue&type=script&lang=js&"
import style0 from "./AdminComponent.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!C:/xampp/htdocs/JeesanEcommerce/vue js--Final_Bk/Vuetify-ECommerce_2018/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib'
import { VCard } from 'vuetify/lib'
import { VChip } from 'vuetify/lib'
import { VContainer } from 'vuetify/lib'
import { VDivider } from 'vuetify/lib'
import { VFlex } from 'vuetify/lib'
import { VIcon } from 'vuetify/lib'
import { VLayout } from 'vuetify/lib'
import { VSpacer } from 'vuetify/lib'
import { VSwitch } from 'vuetify/lib'
import { VTextField } from 'vuetify/lib'
import { VTooltip } from 'vuetify/lib'
installComponents(component, {VBtn,VCard,VChip,VContainer,VDivider,VFlex,VIcon,VLayout,VSpacer,VSwitch,VTextField,VTooltip})
